module.exports = __webpack_public_path__ + "img/dice-6.b9f7775c.svg";